// Import Theme Styles
import "../scss/style.scss";

// Import the parallax script
import { initPromoBannerParallax } from "./partials/PageContent/promoBannerParallax";

// IMPORT OUR NEW REORDER SCRIPT
import { initProductGalleryReorder } from "./productGalleryReorder";

const bootTheme = () => {
  console.log("[Client Theme] Initialized.");

  initPromoBannerParallax();

  // Initialize the Redux Cache interceptor
  initProductGalleryReorder();
};

if (window.EcommerceCore) {
  bootTheme();
} else {
  window.addEventListener("ecommerce_core_ready", bootTheme);
}
